import {profileAPI} from "../API_DAL/api_dal"
import {stopSubmit} from "redux-form";



const SET_PROFILE = "profilePage/SET_PROFILE";
const SET_STATUS = "profilePage/SET_STATUS";
const ADD_POST = "profilePage/ADD_POST";
const TOGGLE_PRELOADER = "profilePage/TOGGLE_PRELOADER";
let initialState = {
    posts: [
        {id: 1, name: "Elaine Dreyfuss", img:"https://lh3.googleusercontent.com/AS2b24SuncRJJNO2yvHCcJeci3zs8g7QbvlifOmNrppfCzeRRLjdB2YU4bJZur3kBDE", lastTime: "9 hours ago", textPost: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempo incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris consequat."},
        {id: 2, name: "Albert Raymond", img:"https://lh3.googleusercontent.com/AS2b24SuncRJJNO2yvHCcJeci3zs8g7QbvlifOmNrppfCzeRRLjdB2YU4bJZur3kBDE",lastTime: "1 hours ago", textPost: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempo incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris consequat."},
        {id: 3, name: "Jonh Carry", img:"https://lh3.googleusercontent.com/AS2b24SuncRJJNO2yvHCcJeci3zs8g7QbvlifOmNrppfCzeRRLjdB2YU4bJZur3kBDE",lastTime: "9 day ago", textPost: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempo incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris consequat."},
        {id: 4, name: "Денис Лариков",img:"https://lh3.googleusercontent.com/AS2b24SuncRJJNO2yvHCcJeci3zs8g7QbvlifOmNrppfCzeRRLjdB2YU4bJZur3kBDE", lastTime: "9 weeks ago", textPost: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempo incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris consequat."},
        {id: 5, name: "Роберт Ванек", img:"https://lh3.googleusercontent.com/AS2b24SuncRJJNO2yvHCcJeci3zs8g7QbvlifOmNrppfCzeRRLjdB2YU4bJZur3kBDE",lastTime: "online", textPost: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempo incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris consequat."},
        {id: 6, name: "Елизабет павп", img:"https://lh3.googleusercontent.com/AS2b24SuncRJJNO2yvHCcJeci3zs8g7QbvlifOmNrppfCzeRRLjdB2YU4bJZur3kBDE",lastTime: "deleted", textPost: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempo incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris consequat."},
        {id: 7, name: "Робби Марго", img:"https://lh3.googleusercontent.com/AS2b24SuncRJJNO2yvHCcJeci3zs8g7QbvlifOmNrppfCzeRRLjdB2YU4bJZur3kBDE",lastTime: "5 hours ago", textPost: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempo incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris consequat."},
        {id: 8, name: "Марго Робби", img:"https://lh3.googleusercontent.com/AS2b24SuncRJJNO2yvHCcJeci3zs8g7QbvlifOmNrppfCzeRRLjdB2YU4bJZur3kBDE",lastTime: "2 hours ago", textPost: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempo incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris consequat."},
        {id: 9, name: "Санька Русский", img:"https://lh3.googleusercontent.com/AS2b24SuncRJJNO2yvHCcJeci3zs8g7QbvlifOmNrppfCzeRRLjdB2YU4bJZur3kBDE",lastTime: "6 hours ago", textPost: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempo incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris consequat."}
    ],
    profile: null,
    status: null,
    isPreloader: false
};

let profileReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_PROFILE:
            return {
                ...state,
                profile: action.profile
            };
        case SET_STATUS:
            return {
                ...state,
                status: action.status
            };
        case ADD_POST:
            return {
                ...state,
                posts: [...state.posts, {id: 12, name: action.name, img: action.img, lastTime: "9 hours ago", textPost: action.text}]
            };
        case TOGGLE_PRELOADER:
            return {
                ...state,
                isPreloader: action.isPreloader
            };
        default:
            return state;
    }
};
export const togglePreloader = (isPreloader) => ({type: TOGGLE_PRELOADER, isPreloader});
export const setProfileSuccess = (profile) => ({type: SET_PROFILE, profile});
export const setStatusSuccess = (status) => ({type: SET_STATUS, status});
export const addPost = (text, img, name) => ({type: ADD_POST, text, img, name});

export const setProfile = (userId) => async(dispatch) => {
    dispatch(togglePreloader(true));
    profileAPI.getProfile(userId).then(data => {
        dispatch(setProfileSuccess(data));
        dispatch(togglePreloader(false));
    })
};
export const setStatus = (userId) => (dispatch) => {
    dispatch(togglePreloader(true));
    profileAPI.getStatus(userId).then(data => {
        dispatch(setStatusSuccess(data))
        dispatch(togglePreloader(false));
    })
};
export const putStatus = (newStatus) => (dispatch) => {
    dispatch(togglePreloader(true));
    profileAPI.putStatus(newStatus).then(data => {
        if (data.resultCode === 0)
            dispatch(setStatusSuccess(newStatus));
        dispatch(togglePreloader(false));
    })
};
export const putProfile = (profile) => (dispatch, getState) => {
    dispatch(togglePreloader(true));
    profileAPI.putProfile(profile).then(data => {
        if (data.resultCode === 0) {
            dispatch(togglePreloader(false));
            dispatch(setProfile(getState().auth.id))
        }
        else {
            let message = data.messages.length > 0 ? data.messages[0] : "Неизвестная ошибка";
            dispatch(stopSubmit('socialNetworks', {_error: message}))
        }
    })
};
export const setImageProfile = (img) => (dispatch, getState) => {
    dispatch(togglePreloader(true));
    profileAPI.setImageProfile(img).then(data => {
        dispatch(setProfile(getState().auth.id)) //////////////////////////заглушка
        dispatch(togglePreloader(false));
    })
};



export default profileReducer;